export const escolarLines = [
  {
    id: 'conjunto-aluno',
    label: 'Conjunto Aluno MDP',
    icon: 'ri-book-open-line',
    description: 'Conjunto Escolar Aluno com tampo em MDP, acabamento superior em fórmica e perfil em PVC. Padronização de tamanhos por cores.',
  },
  {
    id: 'conjunto-professor',
    label: 'Conjunto Professor',
    icon: 'ri-user-star-line',
    description: 'Mesa para professor com estrutura em aço e cadeira. Armários em MDP para organização da sala.',
  },
  {
    id: 'conjunto-modular',
    label: 'Conjuntos Modulares',
    icon: 'ri-layout-grid-line',
    description: 'Conjuntos modulares que se encaixam para formar mesas maiores. Ideais para trabalho em grupo.',
  },
  {
    id: 'conjunto-quadrado',
    label: 'Conjunto Quadrado',
    icon: 'ri-checkbox-blank-line',
    description: 'Conjuntos de atividades quadrados para 4 ou 8 lugares. Tampo em MDP com estrutura em aço.',
  },
  {
    id: 'conjunto-sextavado',
    label: 'Conjunto Sextavado',
    icon: 'ri-shape-line',
    description: 'Conjunto Escolar Aluno Reforçado com tampo sextavado em MDP e estrutura com 6 pés niveladores.',
  },
  {
    id: 'conjunto-retangular',
    label: 'Conjunto Retangular',
    icon: 'ri-rectangle-line',
    description: 'Conjuntos retangulares para 4, 6 ou 8 lugares por faixa etária. Tampo em MDP com acabamento em fórmica.',
  },
  {
    id: 'conjunto-redondo',
    label: 'Conjunto Redondo',
    icon: 'ri-circle-line',
    description: 'Conjuntos de atividades redondos para 4 ou 5 lugares. Tampo em MDP com acabamento em fórmica.',
  },
  {
    id: 'conjunto-refeitorio',
    label: 'Conjunto Refeitório',
    icon: 'ri-restaurant-line',
    description: 'Conjuntos de refeitório com bancos (com ou sem encosto). Tampo em MDP, estrutura em aço com 4 pés. Empilhável.',
  },
];

export const escolarProducts = [
  // ─── CONJUNTO ALUNO MDP ───
  {
    id: 1,
    name: 'Conjunto Aluno MDP – M01',
    line: 'conjunto-aluno',
    description: 'Tampo em MDP, acabamento em fórmica e perfil em PVC. Cor laranja. Altura do aluno: 0,93 a 1,16m.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Laranja'],
    dimensions: '600 x 450 x 464mm',
    badge: null,
    image: '/media/produtos/0222.png',
  },
  {
    id: 2,
    name: 'Conjunto Aluno MDP – M03',
    line: 'conjunto-aluno',
    description: 'Tampo em MDP, acabamento em fórmica e perfil em PVC. Cor amarelo. Altura do aluno: 1,19 a 1,42m.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Amarelo'],
    dimensions: '600 x 450 x 494mm',
    badge: null,
    image: '/media/produtos/0222.png',
  },
  {
    id: 3,
    name: 'Conjunto Aluno MDP – M04',
    line: 'conjunto-aluno',
    description: 'Tampo em MDP, acabamento em fórmica e perfil em PVC. Cor vermelho. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Vermelho'],
    dimensions: '600 x 450 x 644mm',
    badge: null,
    image: '/media/produtos/0222.png',
  },
  {
    id: 4,
    name: 'Conjunto Aluno MDP – M05',
    line: 'conjunto-aluno',
    description: 'Tampo em MDP, acabamento em fórmica e perfil em PVC. Cor verde. Altura do aluno: 1,46 a 1,76m.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Verde'],
    dimensions: '600 x 450 x 710mm',
    badge: null,
    image: '/media/produtos/0222.png',
  },
  {
    id: 5,
    name: 'Conjunto Aluno MDP – M06',
    line: 'conjunto-aluno',
    description: 'Tampo em MDP, acabamento em fórmica e perfil em PVC. Cor azul. Altura do aluno: 1,59 a 1,88m.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Azul'],
    dimensions: '600 x 450 x 760mm',
    badge: null,
    image: '/media/produtos/0222.png',
  },
  {
    id: 6,
    name: 'Conjunto Aluno MDP – MA01',
    line: 'conjunto-aluno',
    description: 'Adaptado para cadeirante. Tampo em MDP, acabamento em fórmica e perfil em PVC. Dimensões ampliadas.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Cinza'],
    dimensions: '900 x 600 x 760mm',
    badge: 'Cadeirante',
    image: '/media/produtos/0222.png',
  },

  // ─── CONJUNTO PROFESSOR ───
  {
    id: 7,
    name: 'Conjunto Professor – MP01',
    line: 'conjunto-professor',
    description: 'Mesa com tampo em MDP 1200x600mm e cadeira. Estrutura em aço com base T. Acabamento melamínico.',
    material: 'MDP + Aço',
    colors: ['Cinza', 'Branco'],
    dimensions: '1200 x 600 x 750mm',
    badge: null,
    image: '/media/produtos/0223.png',
  },
  {
    id: 8,
    name: 'Conjunto Professor – MP02',
    line: 'conjunto-professor',
    description: 'Mesa com tampo em MDP 1200x600mm e cadeira. Estrutura em aço com base central dupla. Acabamento melamínico.',
    material: 'MDP + Aço',
    colors: ['Cinza', 'Branco'],
    dimensions: '1200 x 600 x 750mm',
    badge: null,
    image: '/media/produtos/0223.png',
  },
  {
    id: 9,
    name: 'Armário Baixo – MAB01',
    line: 'conjunto-professor',
    description: 'Armário baixo em MDP com 2 portas e chave. Ideal para guardar materiais didáticos na sala de aula.',
    material: 'MDP',
    colors: ['Branco', 'Cinza'],
    dimensions: '800 x 500 x 750mm',
    badge: null,
    image: '/media/produtos/0223.png',
  },
  {
    id: 10,
    name: 'Armário Médio – MAM01',
    line: 'conjunto-professor',
    description: 'Armário médio em MDP sem porta e com 2 prateleiras. Para exibição e organização de materiais didáticos.',
    material: 'MDP',
    colors: ['Branco', 'Cinza'],
    dimensions: '800 x 500 x 1100mm',
    badge: null,
    image: '/media/produtos/0223.png',
  },
  {
    id: 11,
    name: 'Armário Alto – MAA01',
    line: 'conjunto-professor',
    description: 'Armário alto em MDP com 1 porta e prateleiras internas. Para armazenamento de materiais didáticos.',
    material: 'MDP',
    colors: ['Branco', 'Cinza'],
    dimensions: '800 x 500 x 1600mm',
    badge: null,
    image: '/media/produtos/0223.png',
  },
  {
    id: 12,
    name: 'Armário Misto – MAA02',
    line: 'conjunto-professor',
    description: 'Armário alto misto em MDP com 2 portas e prateleiras internas. Maior capacidade para a sala de aula.',
    material: 'MDP',
    colors: ['Branco', 'Cinza'],
    dimensions: '800 x 500 x 1600mm',
    badge: null,
    image: '/media/produtos/0223.png',
  },

  // ─── CONJUNTOS MODULARES ───
  {
    id: 13,
    name: 'Conjunto Modular – MS11',
    line: 'conjunto-modular',
    description: 'Tampo trapezoidal colorido que se encaixa com outros módulos. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Aço',
    colors: ['Colorido'],
    dimensions: '1210 x 1080 x 644mm',
    badge: null,
    image: '/media/produtos/0224.png',
  },
  {
    id: 14,
    name: 'Conjunto Modular – MS13',
    line: 'conjunto-modular',
    description: 'Tampo trapezoidal colorido que se encaixa com outros módulos. Altura do aluno: 1,19 a 1,42m.',
    material: 'MDP + Aço',
    colors: ['Colorido'],
    dimensions: '1210 x 1080 x 494mm',
    badge: null,
    image: '/media/produtos/0224.png',
  },
  {
    id: 15,
    name: 'Conjunto Sextavado Infantil – MSC01',
    line: 'conjunto-modular',
    description: '6 mesas trapezoidais coloridas que formam um conjunto sextavado. Ideal para educação infantil.',
    material: 'MDP + Aço',
    colors: ['Colorido'],
    dimensions: '1500 x 1400 x 644mm',
    badge: 'Infantil',
    image: '/media/produtos/0224.png',
  },
  {
    id: 16,
    name: 'Conjunto Sextavado Adulto – MSC02',
    line: 'conjunto-modular',
    description: '6 mesas trapezoidais coloridas que formam um conjunto sextavado. Para ensino médio e fundamental II.',
    material: 'MDP + Aço',
    colors: ['Colorido'],
    dimensions: '1500 x 1400 x 750mm',
    badge: 'Adulto',
    image: '/media/produtos/0224.png',
  },
  {
    id: 17,
    name: 'Conjunto Oitavado Infantil – MOC01',
    line: 'conjunto-modular',
    description: '8 mesas trapezoidais coloridas formando conjunto oitavado. Ideal para atividades em grupo na educação infantil.',
    material: 'MDP + Aço',
    colors: ['Colorido'],
    dimensions: '1500 x 1500 x 644mm',
    badge: 'Infantil',
    image: '/media/produtos/0224.png',
  },
  {
    id: 18,
    name: 'Conjunto Oitavado Adulto – MOC02',
    line: 'conjunto-modular',
    description: '8 mesas trapezoidais coloridas formando conjunto oitavado. Para ensino médio, fundamental II e adultos.',
    material: 'MDP + Aço',
    colors: ['Colorido'],
    dimensions: '1500 x 1500 x 750mm',
    badge: 'Adulto',
    image: '/media/produtos/0224.png',
  },

  // ─── CONJUNTO QUADRADO ───
  {
    id: 19,
    name: 'Conjunto Quadrado 8 Lugares – MQ21',
    line: 'conjunto-quadrado',
    description: 'Tampo em MDP, estrutura em aço com 4 pés e perfil em PVC. Altura do aluno: 0,93 a 1,16m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: '1200 x 1200 x 464mm',
    badge: '8 Lugares',
    image: '/media/produtos/0225.png',
  },
  {
    id: 20,
    name: 'Conjunto Quadrado 8 Lugares – MQ23',
    line: 'conjunto-quadrado',
    description: 'Tampo em MDP, estrutura em aço com 4 pés e perfil em PVC. Altura do aluno: 1,19 a 1,42m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: '1200 x 1200 x 494mm',
    badge: '8 Lugares',
    image: '/media/produtos/0225.png',
  },
  {
    id: 21,
    name: 'Conjunto Quadrado 8 Lugares – MQ24',
    line: 'conjunto-quadrado',
    description: 'Tampo em MDP, estrutura em aço com 4 pés e perfil em PVC. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: '1200 x 1200 x 644mm',
    badge: '8 Lugares',
    image: '/media/produtos/0225.png',
  },
  {
    id: 22,
    name: 'Conjunto Quadrado 4 Lugares – MQ01',
    line: 'conjunto-quadrado',
    description: 'Coluna dupla, tampo em MDP, perfil em PVC. Altura do aluno: 0,93 a 1,16m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: '800 x 800 x 464mm',
    badge: '4 Lugares',
    image: '/media/produtos/0225.png',
  },
  {
    id: 23,
    name: 'Conjunto Quadrado 4 Lugares – MQ04',
    line: 'conjunto-quadrado',
    description: 'Coluna dupla, tampo em MDP, perfil em PVC. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: '800 x 800 x 644mm',
    badge: '4 Lugares',
    image: '/media/produtos/0225.png',
  },

  // ─── CONJUNTO SEXTAVADO ───
  {
    id: 24,
    name: 'Conjunto Sextavado – MS01',
    line: 'conjunto-sextavado',
    description: 'Reforçado, tampo sextavado em MDP, 6 pés niveladores. Cor laranja. Altura do aluno: 0,93 a 1,16m.',
    material: 'MDP + Aço',
    colors: ['Laranja'],
    dimensions: '1370 x 1180 x 464mm',
    badge: 'Reforçado',
    image: '/media/produtos/0226.png',
  },
  {
    id: 25,
    name: 'Conjunto Sextavado – MS03',
    line: 'conjunto-sextavado',
    description: 'Reforçado, tampo sextavado em MDP, 6 pés niveladores. Cor amarelo. Altura do aluno: 1,19 a 1,42m.',
    material: 'MDP + Aço',
    colors: ['Amarelo'],
    dimensions: '1370 x 1180 x 494mm',
    badge: 'Reforçado',
    image: '/media/produtos/0226.png',
  },
  {
    id: 26,
    name: 'Conjunto Sextavado – MS04',
    line: 'conjunto-sextavado',
    description: 'Reforçado, tampo sextavado em MDP, 6 pés niveladores. Cor vermelho. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Aço',
    colors: ['Vermelho'],
    dimensions: '1370 x 1180 x 644mm',
    badge: 'Reforçado',
    image: '/media/produtos/0226.png',
  },
  {
    id: 27,
    name: 'Conjunto Sextavado – MS05',
    line: 'conjunto-sextavado',
    description: 'Reforçado, tampo sextavado em MDP, 6 pés niveladores. Cor verde. Altura do aluno: 1,46 a 1,76m.',
    material: 'MDP + Aço',
    colors: ['Verde'],
    dimensions: '1370 x 1180 x 710mm',
    badge: 'Reforçado',
    image: '/media/produtos/0226.png',
  },
  {
    id: 28,
    name: 'Conjunto Sextavado – MS06',
    line: 'conjunto-sextavado',
    description: 'Reforçado, tampo sextavado em MDP, 6 pés niveladores. Cor azul. Altura do aluno: 1,59 a 1,88m.',
    material: 'MDP + Aço',
    colors: ['Azul'],
    dimensions: '1370 x 1180 x 760mm',
    badge: 'Reforçado',
    image: '/media/produtos/0226.png',
  },

  // ─── CONJUNTO RETANGULAR ───
  {
    id: 29,
    name: 'Conjunto Retangular 4 Lugares – MR43',
    line: 'conjunto-retangular',
    description: 'Para crianças de 6 a 7 anos. Tampo em MDP com fórmica, estrutura coluna dupla e perfil em PVC.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: '1200 x 780 x 590mm',
    badge: '6-7 anos',
    image: '/media/produtos/0227.png',
  },
  {
    id: 30,
    name: 'Conjunto Retangular 4 Lugares – MR44',
    line: 'conjunto-retangular',
    description: 'Para crianças de 8 a 10 anos. Tampo em MDP com fórmica, estrutura coluna dupla e perfil em PVC.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: '1200 x 780 x 640mm',
    badge: '8-10 anos',
    image: '/media/produtos/0227.png',
  },
  {
    id: 31,
    name: 'Conjunto Retangular 4 Lugares – MR46',
    line: 'conjunto-retangular',
    description: 'Para 14+ anos. Tampo em MDP com fórmica, estrutura coluna dupla e perfil em PVC.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: '1200 x 780 x 760mm',
    badge: '14+ anos',
    image: '/media/produtos/0227.png',
  },
  {
    id: 32,
    name: 'Conjunto Retangular 6 Lugares – MR64',
    line: 'conjunto-retangular',
    description: 'Para crianças de 8 a 10 anos. Tampo em MDP com fórmica, estrutura coluna dupla e perfil em PVC.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: '1800 x 780 x 640mm',
    badge: '6 Lugares',
    image: '/media/produtos/0227.png',
  },
  {
    id: 33,
    name: 'Conjunto Retangular 8 Lugares – MR74',
    line: 'conjunto-retangular',
    description: 'Para crianças de 8 a 10 anos. Tampo em MDP com fórmica, estrutura coluna dupla e perfil em PVC.',
    material: 'MDP + Fórmica + PVC',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: '2100 x 780 x 640mm',
    badge: '8 Lugares',
    image: '/media/produtos/0227.png',
  },

  // ─── CONJUNTO REDONDO ───
  {
    id: 34,
    name: 'Conjunto Redondo 5 Lugares – CJR01',
    line: 'conjunto-redondo',
    description: 'Tampo em MDP, 5 pés niveladores, acabamento em fórmica. Altura do aluno: 0,93 a 1,16m.',
    material: 'MDP + Fórmica',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: 'Ø1200 x 464mm',
    badge: '5 Lugares',
    image: '/media/produtos/0228.png',
  },
  {
    id: 35,
    name: 'Conjunto Redondo 5 Lugares – CJR03',
    line: 'conjunto-redondo',
    description: 'Tampo em MDP, 5 pés niveladores, acabamento em fórmica. Altura do aluno: 1,19 a 1,42m.',
    material: 'MDP + Fórmica',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: 'Ø1200 x 494mm',
    badge: '5 Lugares',
    image: '/media/produtos/0228.png',
  },
  {
    id: 36,
    name: 'Conjunto Redondo 5 Lugares – CJR04',
    line: 'conjunto-redondo',
    description: 'Tampo em MDP, 5 pés niveladores, acabamento em fórmica. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Fórmica',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo'],
    dimensions: 'Ø1200 x 644mm',
    badge: '5 Lugares',
    image: '/media/produtos/0228.png',
  },
  {
    id: 37,
    name: 'Conjunto Redondo 4 Lugares – CJR11',
    line: 'conjunto-redondo',
    description: 'Tampo em MDP, 4 pés niveladores, acabamento em fórmica. Altura do aluno: 0,93 a 1,16m.',
    material: 'MDP + Fórmica',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: 'Ø900 x 464mm',
    badge: '4 Lugares',
    image: '/media/produtos/0228.png',
  },
  {
    id: 38,
    name: 'Conjunto Redondo 4 Lugares – CJR13',
    line: 'conjunto-redondo',
    description: 'Tampo em MDP, 4 pés niveladores, acabamento em fórmica. Altura do aluno: 1,19 a 1,42m.',
    material: 'MDP + Fórmica',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: 'Ø900 x 494mm',
    badge: '4 Lugares',
    image: '/media/produtos/0228.png',
  },
  {
    id: 39,
    name: 'Conjunto Redondo 4 Lugares – CJR14',
    line: 'conjunto-redondo',
    description: 'Tampo em MDP, 4 pés niveladores, acabamento em fórmica. Altura do aluno: 1,33 a 1,59m.',
    material: 'MDP + Fórmica',
    colors: ['Azul', 'Vermelho', 'Verde', 'Amarelo', 'Laranja'],
    dimensions: 'Ø900 x 644mm',
    badge: '4 Lugares',
    image: '/media/produtos/0228.png',
  },

  // ─── CONJUNTO REFEITÓRIO ───
  {
    id: 40,
    name: 'Conjunto Refeitório – RE13',
    line: 'conjunto-refeitorio',
    description: 'Bancos sem encosto. Tampo em MDP, estrutura em aço com 4 pés, perfil em PVC. Empilhável. Altura: 1,19 a 1,42m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Amarelo', 'Verde'],
    dimensions: '1500 x 700 x 494mm',
    badge: null,
    image: '/media/produtos/0229.png',
  },
  {
    id: 41,
    name: 'Conjunto Refeitório – RE16',
    line: 'conjunto-refeitorio',
    description: 'Bancos sem encosto. Tampo em MDP, estrutura em aço com 4 pés, perfil em PVC. Empilhável. Altura: 1,59 a 1,88m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Amarelo', 'Verde'],
    dimensions: '1500 x 700 x 760mm',
    badge: null,
    image: '/media/produtos/0229.png',
  },
  {
    id: 42,
    name: 'Conjunto Refeitório – RE23',
    line: 'conjunto-refeitorio',
    description: 'Bancos sem encosto, mesa maior. Tampo em MDP, estrutura em aço, perfil em PVC. Empilhável. Altura: 1,19 a 1,42m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Amarelo', 'Verde'],
    dimensions: '1800 x 700 x 494mm',
    badge: null,
    image: '/media/produtos/0229.png',
  },
  {
    id: 43,
    name: 'Conjunto Refeitório – RE26',
    line: 'conjunto-refeitorio',
    description: 'Bancos sem encosto, mesa maior. Tampo em MDP, estrutura em aço, perfil em PVC. Empilhável. Altura: 1,59 a 1,88m.',
    material: 'MDP + Aço + PVC',
    colors: ['Azul', 'Vermelho', 'Amarelo', 'Verde'],
    dimensions: '1800 x 700 x 760mm',
    badge: null,
    image: '/media/produtos/0229.png',
  },
  {
    id: 44,
    name: 'Conjunto Refeitório com Encosto – RE53',
    line: 'conjunto-refeitorio',
    description: 'Bancos com encosto para mais conforto. Tampo em MDP, estrutura em aço, perfil em PVC. Altura: 1,19 a 1,42m.',
    material: 'MDP + Aço + PVC',
    colors: ['Amarelo', 'Azul', 'Vermelho', 'Verde'],
    dimensions: '1500 x 700 x 494mm',
    badge: 'Com Encosto',
    image: '/media/produtos/0229.png',
  },
  {
    id: 45,
    name: 'Conjunto Refeitório com Encosto – RE56',
    line: 'conjunto-refeitorio',
    description: 'Bancos com encosto para mais conforto, mesa maior. Tampo em MDP, estrutura em aço, perfil em PVC. Altura: 1,59 a 1,88m.',
    material: 'MDP + Aço + PVC',
    colors: ['Amarelo', 'Azul', 'Vermelho', 'Verde'],
    dimensions: '1800 x 700 x 760mm',
    badge: 'Com Encosto',
    image: '/media/produtos/0229.png',
  },
];
